import React from "react";
import { 
  Box, 
  Typography, 
  Paper, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow,
  Chip,
  CircularProgress
} from "@mui/material";
import { useParams } from "react-router-dom";
import { useCustomQuery } from "store/hooks/react-query/query/useQuery";
import moment from "moment";

const PrescriptionHistory = () => {
  const { id } = useParams(); // Patient ID from URL

  const { data: prescriptionData, isLoading } = useCustomQuery(
    ["GET_PATIENT_PRESCRIPTIONS_HISTORY", id],
    {
        url: `/prescription/${id}`, 
        method: "get",
        // Pass query params as an object to ensure they are handled as numbers
        
    },
    {
        enabled: !!id,
    }
  );

  const prescriptions = prescriptionData?.data?.prescriptions || [];

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
        Prescription History
      </Typography>

      {prescriptions.length === 0 ? (
        <Paper sx={{ p: 3, textAlign: "center" }}>
          <Typography color="textSecondary">No prescription records found.</Typography>
        </Paper>
      ) : (
        <TableContainer component={Paper} sx={{ boxShadow: "none", border: "1px solid #eee" }}>
          <Table>
            <TableHead sx={{ backgroundColor: "#f9f9f9" }}>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Doctor</TableCell>
                <TableCell>Prescribed Items</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {prescriptions.map((pres) => (
                <TableRow key={pres._id}>
                  <TableCell sx={{ whiteSpace: 'nowrap' }}>
                    {moment(pres.createdAt).format("DD MMM, YYYY")}
                  </TableCell>
                  <TableCell>
                    {pres.doctor ? `Dr. ${pres.doctor.firstName} ${pres.doctor.lastName}` : "N/A"}
                  </TableCell>
                  <TableCell>
                    <Box component="ul" sx={{ m: 0, pl: 2 }}>
                      {pres.items?.map((item, idx) => (
                        <li key={idx}>
                          <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            {/* Note: product population is needed in backend for drugName to show */}
                            {item.product?.drugName || "Unknown Drug"} — {item.amount} {item.frequency} ({item.duration} days)
                          </Typography>
                        </li>
                      ))}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Chip 
                      label={pres.status} 
                      size="small"
                      color={pres.status === "DISPENSED" ? "success" : "primary"}
                      variant="outlined"
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default PrescriptionHistory;